import { useState } from "react";
import styled from "styled-components";

import Button from "./Button";

export const StyledDialog = styled.dialog`
    background: #fff;
    border: none;
    border-radius: 8px;
    padding: 32px;
    position: fixed;

    &::backdrop {
        background: #0007;
    }
`;

const Styled = styled.form`
    display: flex;
    flex-direction: column;
    gap: 32px;
    max-height: 70vh;
    max-width: 50vw;

    h1 {
        font-family: var(--font-mono), monospace;
        font-weight: normal;
        margin: 0;
    }

    footer {
        display: flex;
        flex-direction: row;
        gap: 8px;
        justify-content: flex-end;
    }
`;

export default function Confirm(props) {
    const { no, yes, ...restProps } = props;

    const [disabled, setDisabled] = useState(false);

    async function onSubmit(event) {
        event.preventDefault();
        setDisabled(true);
        await yes();
        setDisabled(false);
    }

    return (
        <Styled
            { ...restProps }
            onSubmit={ onSubmit }
        >
            { props.children }
            <footer>
                <Button
                    autoFocus
                    disabled={ disabled }
                    type="submit"
                    size="small"
                >
                    OK
                </Button>
                <Button
                    disabled={ disabled }
                    onClick={ no }
                    type="button"
                    variant="outline"
                    size="small"
                >
                    Cancel
                </Button>
            </footer>
        </Styled>
    );
}
